import {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

import {
  addToCart as addToCartApi,
  getCart as getCartApi,
  increaseQuantity as increaseQuantityApi,
  decreaseQuantity as decreaseQuantityApi,
  removeFromCart as removeFromCartApi,
  clearCart as clearCartApi,
} from "../services/cartApi";

// ==========================================
// Create Context
// ==========================================

const CartContext = createContext();

// ==========================================
// Provider
// ==========================================

export const CartProvider = ({ children }) => {

  const [cartItems, setCartItems] = useState([]);

  const [totals, setTotals] = useState({
    subtotal: 0,
    deliveryCharge: 0,
    grandTotal: 0,
    totalItems: 0,
  });

  const [loading, setLoading] = useState(false);

  // ==========================================
  // Load Cart
  // ==========================================

  const fetchCart = async () => {

    try {

      const token = localStorage.getItem("token");

      if (!token) {
        return;
      }

      setLoading(true);

      const res = await getCartApi();
      console.log(res.cart);

      if (res.success) {

        setCartItems(res.cart || []);

        setTotals(
          res.totals || {
            subtotal: 0,
            deliveryCharge: 0,
            grandTotal: 0,
            totalItems: 0,
          }
        );

      }

    } catch (error) {

      console.log("Fetch Cart Error:", error);

    } finally {

      setLoading(false);

    }

  };

  // ==========================================
  // Add To Cart
  // ==========================================

 const addToCart = async (foodId) => {

  console.log("===== CartContext =====");
  console.log("Received foodId:", foodId);

  try {

    const res = await addToCartApi(foodId);

    console.log("Response:", res);

    if (res.success) {
      setCartItems(res.cart);
      setTotals(res.totals);
    }

  } catch (error) {
    console.log(error);
  }

};
  // ==========================================
  // Increase Quantity
  // ==========================================

  const increaseQuantity = async (foodId) => {

    try {

      const res = await increaseQuantityApi(foodId);

      if (res.success) {

        setCartItems(res.cart);

        setTotals(res.totals);

      }

    } catch (error) {

      console.log(error);

    }

  };

  // ==========================================
  // Decrease Quantity
  // ==========================================

  const decreaseQuantity = async (foodId) => {

    try {

      const res = await decreaseQuantityApi(foodId);

      if (res.success) {

        setCartItems(res.cart);

        setTotals(res.totals);

      }

    } catch (error) {

      console.log(error);

    }

  };
    // ==========================================
  // Remove Item
  // ==========================================

  const removeFromCart = async (foodId) => {

    try {

      const res = await removeFromCartApi(foodId);

      if (res.success) {

        setCartItems(res.cart);

        setTotals(res.totals);

      }

    } catch (error) {

      console.log(error);

    }

  };

  // ==========================================
  // Clear Cart
  // ==========================================

  const clearCart = async () => {

    try {

      const res = await clearCartApi();

      if (res.success) {

        setCartItems([]);

        setTotals({
          subtotal: 0,
          deliveryCharge: 0,
          grandTotal: 0,
          totalItems: 0,
        });

      }

    } catch (error) {

      console.log(error);

    }

  };

  // ==========================================
  // Get Food Quantity
  // ==========================================
const getFoodQuantity = (foodId) => {

  console.log("Checking Food:", foodId);

  console.log("Cart Items:", cartItems);

  const item = cartItems.find((cart) => {

    console.log("Cart Food:", cart.foodId);

    if (!cart.foodId) return false;

    return (
      String(cart.foodId._id) === String(foodId) ||
      String(cart.foodId.id) === String(foodId)
    );

  });

  console.log("Matched Item:", item);

  return item ? item.quantity : 0;

};



// ==========================================
// Total Cart Items
// ==========================================

const getCartItemCount = () => {
  return totals.totalItems;
};

// ==========================================
// Grand Total
// ==========================================

const getGrandTotal = () => {
  return totals.grandTotal;
};

  // ==========================================
  // Auto Load Cart
  // ==========================================

  useEffect(() => {

    fetchCart();

  }, []);

  // ==========================================
  // Provider
  // ==========================================

  return (

    <CartContext.Provider
      value={{

        cartItems,
        totals,
        loading,

        fetchCart,

        addToCart,

        increaseQuantity,

        decreaseQuantity,

        removeFromCart,

        clearCart,

        getFoodQuantity,
        getCartItemCount,
getGrandTotal,

      }}
    >

      {children}

    </CartContext.Provider>

  );

};

// ==========================================
// Custom Hook
// ==========================================

export const useCart = () => {

  return useContext(CartContext);

};